import home from './home'

const pageRouters = [
  home
]

export default pageRouters



// WEBPACK FOOTER //
// ./src/router/pageRouters.js